

const progressDoughnutChartData = {
  labels: ["Done", "In progress"],
  datasets: {
    label: "Projects",
    backgroundColors: ["info", "secondary"],
    data: [75, 25],
  },
};

export default progressDoughnutChartData;
